export enum EMenuItemAliasView {
  VISIBLE,
  HIDDEN,
  DISABLED,
}
